// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

	// * weatherApi
	// *
	// * get current data of weahter Api

	const WEATHER_API_CONF = {
		target: "#weather",
		target_mobile: "#weather_data_mobile",
		targets: {
			booking: "#weather_data_booking",
		},
		api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
		zip: "92262,us",
		lat: 36.623832,
		lon: -121.9180822,
		units: "imperial",
		getters: {
			// Coordinates by zip/post code
			coordinates: `https://api.openweathermap.org/geo/1.0/zip?zip={zip}&appid={api_key}`,
			// Call current weather data
			current_weather: `https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={api_key}`,
		},
		url_icon: "https://openweathermap.org/img/wn/",
	};

	const weatherApi = () => {
		let weatherBox = document.querySelector(WEATHER_API_CONF.target);
		let weatherBoxBooking = document.querySelector(
			WEATHER_API_CONF.targets.booking
		);
		let weatherBoxMobile = document.querySelector(
			WEATHER_API_CONF.target_mobile
		);

		let urlApi = `${WEATHER_API_CONF.getters.current_weather}&units=${WEATHER_API_CONF.units}`;
		urlApi = urlApi.replace("{lat}", WEATHER_API_CONF.lat);
		urlApi = urlApi.replace("{lon}", WEATHER_API_CONF.lon);
		urlApi = urlApi.replace("{api_key}", WEATHER_API_CONF.api_key);

		fetch(urlApi)
			.then((response) => response.json())
			.then((data) => {
				let weatherIcon = data.weather[0].icon;
				let weatherTemp = data.main.temp;

				const documentRange = document.createRange();
				const stringHtml = `
					<div class="weather__icon" style="background-image: url(${SITE_FILES}images/weatherapi/${weatherIcon}.png);"></div>
					<div class="weather__label">${weatherTemp.toFixed(1)} °F</div>
				`;

				if (weatherBox !== null) {
					const htmlFragmentBox =
						documentRange.createContextualFragment(stringHtml);
					weatherBox.appendChild(htmlFragmentBox);

					if (weatherBoxBooking !== null) {
						const htmlFragmentBooking =
							documentRange.createContextualFragment(stringHtml);
						weatherBoxBooking.append(htmlFragmentBooking);
					}
				}
				if (weatherBoxMobile !== null) {
					const htmlFragmentBoxMobile =
						documentRange.createContextualFragment(stringHtml);
					weatherBoxMobile.appendChild(htmlFragmentBoxMobile);
				}
			});
	};

	weatherApi()

	});

	document.addEventListener('DOMContentLoaded', () => {

		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('#calendarContainer').datepicker("setDate", start);
			$(this).attr('value', start);
		});

		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('#calendarContainer').datepicker("setDate", end);
			$(this).attr('value', end);
		});

		$("#closeFake, #adults_home").click(function(){
			$('#fakeInput').fadeOut();
		})

		$('#calendarContainer').datepicker({
			changeMonth: false,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 2,
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				//console.log(date,date.getTime(),start,end);
				let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				let endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					$('#fakeInput').fadeOut();
					opencheck = 1;
					firstClick = 0;
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
				$('#altDates').attr('value', start + ' / ' + end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		$("input[name=zip_code]").attr("maxlength", "5");

	});

	window.onload = function() {
		scrollW();
		changeMenuColor();
		window.addEventListener('scroll', function(){
			scrollW();
			changeMenuColor();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 30){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector('.sitemap')){
			document.getElementById('header').classList.add('down')
		}
	}
	if(document.getElementsByClassName('top-content__header')[0]){
		let topContentUvp = document.getElementsByClassName('top-content__header')[0].offsetHeight + 220;
		if(st > topContentUvp){
			document.querySelector('.header .header__top').classList.remove('hidden-header');
			document.getElementsByClassName('top-content__header')[0].classList.add('opacity')
		}else{
			document.querySelector('.header .header__top').classList.add('hidden-header');
			document.getElementsByClassName('top-content__header')[0].classList.remove('opacity')
		}
	}	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeMenuColor() {
	var fixed = $(".js-open-menu");

    var fixed_position = $(".js-open-menu").offset().top;
    var fixed_height = $(".js-open-menu").height();

    var addClass = false;
    $('.dark-bg').each(function(){

        var toCross_position = $(this).offset().top;
        var toCross_height = $(this).height();

        if (fixed_position + fixed_height  < toCross_position) {
            
        } else if (fixed_position > toCross_position + toCross_height) {
           
        } else {
            addClass = true;
        }
    });
    if(addClass == true){
        fixed.addClass('change-color');
    }else{
        fixed.removeClass('change-color');
    }
}